import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function Z8() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.teaser');

    return (
        <div className={`d2x-Z8 ${css.d2xZ8}`}>
            <div className="sec8">
                <div className="text-box">
                    <p className="title">{t('z8_au_title')}</p>
                    <p className="desc">{t('z8_au_desc')}</p>
                    <p className="tips">{t('z8_au_tips')}</p>
                </div>
                <div className="img-box">
                    <NextImage src={require('@publicLocal/delta2max/teaser/pc/eu/au_4.jpg')} alt={t('z8_au_title')} aria-label={t('z8_au_title')} />
                </div>
            </div>
        </div>
    );
}
